<template>
  <div class="container">
    <div class="item" v-for="(item, index) in dataSource" :key="index">
      <div class="circle-icon">
        <span class="iconfont" :class="item.iconClass"></span>
      </div>
      <div class="content-text">
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  computed:{
    dataSource(){
      return [
        { id: 0, iconClass: "icon-dangqian", title: this.$t('query.stepsCard.item01.title'), desc: this.$t('query.stepsCard.item01.desc') },
        { id: 1, iconClass: "icon-dianzan-mianxing", title: this.$t('query.stepsCard.item02.title'), desc: this.$t('query.stepsCard.item02.desc')},
        { id: 2, iconClass: "icon-vip", title: this.$t('query.stepsCard.item03.title'), desc: this.$t('query.stepsCard.item03.desc') },
        { id: 3, iconClass: "icon-baozhang-copy", title: this.$t('query.stepsCard.item04.title'), desc: this.$t('query.stepsCard.item04.desc') },
        { id: 4, iconClass: "icon-guojiwuliu", title: this.$t('query.stepsCard.item05.title'), desc: this.$t('query.stepsCard.item05.desc') },
      ]
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  // background-color: #ccc;
  box-sizing: border-box;
  padding: 140px 48px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: flex-start;

  .item {
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .circle-icon {
      box-sizing: border-box;
      width: 120px;
      height: 120px;
      border-radius: 50%;
      background-color: #ececec;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 48px;
      }
    }

    .content-text {
      .title {
        margin: 12px 0 0 0;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
      }
      .desc {
        text-align: center;
      }
    }
  }
}
</style>